/* build-bust 2026-03-10T01 */
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./lib/register-sw";

createRoot(document.getElementById("root")!).render(<App />);
